module.exports = __webpack_public_path__ + "b06871f281fee6b241d60582ae9369b9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/vendor/font-awesome-4.7.0/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 701
// module chunks = 49